import { SpotlightKey } from '@reach/interfaces/spotlights/spotlights.enum';

import { InfoModalKey } from '~app-client/info-modals/types';

export const ONBOARDING_TO_INFO_MODAL_MAP: Partial<Record<SpotlightKey, InfoModalKey>> = {
	[SpotlightKey.CORE__LOCATION]: InfoModalKey.LOCATION,

	[SpotlightKey.CHAT__INITIAL_INFO]: InfoModalKey.CHAT_AI_HOW_IT_WORKS,

	[SpotlightKey.SEARCH__SELECT_MULTIPLE_WORKSPACES_MOBILE]: InfoModalKey.CHANGE_WORKSPACE,
	[SpotlightKey.SEARCH__SELECT_MULTIPLE_WORKSPACES_DESKTOP]: InfoModalKey.CHANGE_WORKSPACE,

	[SpotlightKey.SEARCH__ADVANCED__PROPERTIES__ADD]: InfoModalKey.SEARCH_PROPERTIES_FILTER,
	[SpotlightKey.SEARCH__ADVANCED__PROPERTIES__CHANGE_OPERATOR]:
		InfoModalKey.SEARCH_PROPERTIES_FILTER,

	[SpotlightKey.SEARCH__VIEWS__VISUALISER__SHOW_LABELS]: InfoModalKey.SEARCH_VIEW_VISUALISER,

	[SpotlightKey.NODE_INFO__INITIAL]: InfoModalKey.NODE_INFO_INITIAL,
	[SpotlightKey.NODE_INFO__RELATIONSHIPS__ADD]: InfoModalKey.NODE_INFO_RELATIONSHIPS,
	[SpotlightKey.NODE_INFO__PROPERTIES__ADD]: InfoModalKey.NODE_INFO_PROPERTIES,
	[SpotlightKey.NODE_INFO__RELATIONSHIPS__RECOMMENDATIONS]:
		InfoModalKey.NODE_INFO_RECOMMENDATIONS,

	[SpotlightKey.NODE_CREATION__NODE_TYPE__NOTE]: InfoModalKey.NODE_CREATION_NOTE,
	[SpotlightKey.NODE_CREATION__NODE_TYPE__TAG]: InfoModalKey.NODE_CREATION_TAG,
	[SpotlightKey.NODE_CREATION__NODE_TYPE__FILE]: InfoModalKey.NODE_CREATION_FILE,
	[SpotlightKey.NODE_CREATION__NODE_TYPE__WEBSITE]: InfoModalKey.NODE_CREATION_WEBSITE,
	[SpotlightKey.NODE_CREATION__NODE_TYPE__WORKSPACE]: InfoModalKey.NODE_CREATION_WORKSPACE,

	[SpotlightKey.INTEGRATIONS__FIRST_TIME]: InfoModalKey.INTEGRATIONS_FIRST_TIME,

	[SpotlightKey.CHAT_AI_LEARN_ALL]: InfoModalKey.CHAT_AI_LEARN_ALL,
};
